module.exports = __webpack_public_path__ + "static/media/img13.ec5c6416.jpg";